<div
  class="wrapper"
  [class]="{
    'disabled-control': isEdit && !isEditable,
    'has-background': !!getSelectedDataColor()
  }"
  [matTooltip]="getStringValue()"
  [matTooltipShowDelay]="1500"
>
  @if (isPossibleToEdit()) {
    <input
      #inputElement
      class="mat-select-input"
      matInput
      (focusin)="handleSelectClick()"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchTermChange($event)"
      (keydown.arrowUp)="onArrowKey($event, 'up')"
      (keydown.arrowDown)="onArrowKey($event, 'down')"
      (keydown.enter)="onEnter($event)"
    >
    <mat-select
      #matSelect
      [(ngModel)]="value"
      [required]="required"
      [style.background-color]="getSelectedDataColor()"
      (closed)="clearSearchTerm()"
      (selectionChange)="handleSelectChange($event)"
      [placeholder]="getPlaceholder()"
    >
      @if (!isEmptyOptions) {
        <mat-option value=""></mat-option>
      }
      @for (option of filteredOptions(); track $index) {
        @if (isOptionShouldBeDisplayed(option)) {
          <mat-option
            [value]="option.id"
            [class.mat-option-select]="option.id === selectedIndex"
            [style.background-color]="getColorWithOpacity(option.color, 0.35)"
            [style.zoom]="getScalingFactor(currentTableZoom)"
          >
            {{ option.value }}
          </mat-option>
        }
      }
      @if (isEmptyOptions) {
        <div class="empty-options">
          Нет данных
        </div>
      }
    </mat-select>
  } @else {
    <div
      class="displayed-value"
      [style.background-color]="getSelectedDataColor()"
    >
      {{ getSelectedData()?.value }}
    </div>
  }
</div>
